import * as _ from 'lodash';
import * as types from './types';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  students: [],
  totalPages: 0,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.STUDENTLOOKUP_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.STUDENTLOOKUP_FETCH:
      return {
        ...state,
        students: payload.Data.Result.map(student => ({
          ...student,
          [Fields.BirthDate]: defaultDateFormat(student[Fields.BirthDate]),
        })),
        totalPages: payload.Data.TotalPages,
      };

    case types.STUDENTLOOKUP_FETCH_ERROR:
      if (_.has(payload, 'response.data')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching students. Please try again',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/studentlookup/reducer.js